module.exports = __webpack_public_path__ + "img/hs_ev3.2d9ba083.png";